import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AdminConfigService } from '@modeso/dgoods-lib-admin-fe';
import { ProductSettingsDTO } from '@modeso/types__dgoods-products';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProductsService {
    private readonly server = '';
    private readonly microserviceName = 'products';

    /**
     *
     * @param http
     * @param config
     */
    constructor(
        private readonly http: HttpClient,
        @Inject(AdminConfigService) private readonly config,
    ) {
        this.server = config.apiGateway;
    }

    getProductsSettings(): Observable<ProductSettingsDTO[]> {
        const url = `${this.server}${this.microserviceName}/settings`;
        return this.http.get<ProductSettingsDTO[]>(url);
    }

    updateProductSettings(productSettings: ProductSettingsDTO): Observable<ProductSettingsDTO> {
        const { productLineName, ...rest } = productSettings;
        const url = `${this.server}${this.microserviceName}/updateProductSettings/${productLineName}`;
        return this.http.post<ProductSettingsDTO>(url, rest);
    }
}
